import React, { useEffect, useState } from 'react'
import { MainContext, useContext } from '../../Main/MainContext'
import Layout from '../../Components/Layout'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useNavigation, useParams } from 'react-router-dom'

import { api, server, prefix, endpoints } from '../../Main/Api';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import TedaviProtokolu from '../../Components/TedaviProtokolu'
import Modal from 'react-modal';

import moment from "moment";

const MySwal = withReactContent(Swal)

export default function Ata() {

    useEffect(() => {
        Modal.setAppElement('#root');
    }, [])

    const { user, token } = useContext(MainContext)
    const { t } = useTranslation()
    const { kullanici_kodu: kk } = useParams()
    const navigate = useNavigate()


    const [loading, setLoading] = useState(false)
    const [recete, setRecete] = useState()
    const [ayarlar, setAyarlar] = useState()
    const [takvim, setTakvim] = useState([])
    const [urinGun, setUriGun] = useState(2)
    const [baslangicTarihi, setBaslangicTarihi] = useState(new Date().toISOString().slice(0, 10))
    const [btnLoading, setBtnLoading] = useState(false)

    const [maModal, setMaModal] = useState(false)
    const [maAksiyon, setMaAksiyon] = useState("")
    const [maTarih, setMaTarih] = useState(null)

    const [maEditModal, setMaEditModal] = useState(false)
    const [maEditAksiyon, setMaEditAksiyon] = useState("")
    const [maEditTarih, setEditMaTarih] = useState(null)
    const [maEditUuid, setEditMaUuid] = useState("")

    useEffect(() => {
        setLoading(true)
        const url = server + prefix + endpoints.recete_ayarlari
        api.request(url, "GET", null, { "Authorization": "Bearer " + token }).then((response) => {
            const { data } = response.data;

            setAyarlar(data)

            setLoading(false)
        });
    }, [])

    useEffect(() => {

        if (recete == null || urinGun == null || baslangicTarihi == null) {
            return;
        }

        if (recete != null) {
            takvimOlustur()
        }

    }, [recete, urinGun, baslangicTarihi])

    const takvimOlustur = () => {
        let aksiyonTarihi = moment(baslangicTarihi);
        let seansNo = 1;
        const tmpTakvim = [
            {
                uuid: crypto.randomUUID(),
                tarih: aksiyonTarihi.format('DD-MM-YYYY'),
                aksiyon: "TEDAVI",
                label: "tedavi",
                seans_no: seansNo
            },
            {
                uuid: crypto.randomUUID(),
                tarih: aksiyonTarihi.format('DD-MM-YYYY'),
                aksiyon: "ANKET",
                label: "anket",
                seans_no: seansNo
            },
            {
                uuid: crypto.randomUUID(),
                tarih: aksiyonTarihi.format('DD-MM-YYYY'),
                aksiyon: "URINER",
                label: "uriner",
                seans_no: seansNo
            },
        ];


        aksiyonTarihi = moment(aksiyonTarihi).add(urinGun, 'days');
        let tedaviAraligi = (7 / recete.siklik);
        tedaviAraligi = (tedaviAraligi % 1 === 0) ? tedaviAraligi : Math.floor(tedaviAraligi)

        const toplamSeans = recete.hafta_sayisi * recete.siklik;
        const takvimOrtasi = parseInt(toplamSeans / 2);

        for (var i = 0; i < toplamSeans; i++) {
            if (i == takvimOrtasi) {

                aksiyonTarihi = moment(aksiyonTarihi).add(-1, 'days');

                tmpTakvim.push({
                    uuid: crypto.randomUUID(),
                    tarih: aksiyonTarihi.format('DD.MM.YYYY'),
                    aksiyon: "ANKET",
                    label: "anket",
                    seans_no: seansNo
                })

                tmpTakvim.push({
                    uuid: crypto.randomUUID(),
                    tarih: aksiyonTarihi.format('DD.MM.YYYY'),
                    aksiyon: "URINER",
                    label: "uriner",
                    seans_no: seansNo
                })

                aksiyonTarihi = moment(aksiyonTarihi).add(urinGun, 'days');

            } else {
                seansNo++;
                tmpTakvim.push({
                    uuid: crypto.randomUUID(),
                    tarih: aksiyonTarihi.format('DD.MM.YYYY'),
                    aksiyon: "TEDAVI",
                    label: "tedavi",
                    seans_no: seansNo
                })
                aksiyonTarihi = moment(aksiyonTarihi).add(tedaviAraligi, 'days');
            }
        }

        aksiyonTarihi = moment(aksiyonTarihi).add(-1, 'days');

        tmpTakvim.push({
            uuid: crypto.randomUUID(),
            tarih: aksiyonTarihi.format('DD.MM.YYYY'),
            aksiyon: "URINER",
            label: "uriner",
            seans_no: seansNo
        })
        aksiyonTarihi = moment(aksiyonTarihi).add(urinGun, 'days');

        tmpTakvim.push({
            uuid: crypto.randomUUID(),
            tarih: aksiyonTarihi.format('DD.MM.YYYY'),
            aksiyon: "TEDAVI",
            label: "tedavi",
            seans_no: seansNo
        })
        tmpTakvim.push({
            uuid: crypto.randomUUID(),
            tarih: aksiyonTarihi.format('DD.MM.YYYY'),
            aksiyon: "ANKET",
            label: "anket",
            seans_no: seansNo
        })

        setTakvim(tmpTakvim);
    }

    const recete_onizleme = () => {
        setLoading(true)
        let url = server + prefix + endpoints.recete_onizleme.replace(":id", recete.id);
        api.request(url, "GET", {
            baslangic_tarihi: baslangicTarihi,
            uriner_gun: urinGun
        }, {
            "Authorization": "Bearer " + token
        }).then((response) => {
            const { data: responseData } = response;

            setTakvim(responseData.data);

            setLoading(false)
        }).catch((err) => {
            setLoading(true)
        })
    }

    const urinerKontrol = () => {
        return new Promise((resolve) => {
            let hataVar = false;


            takvim.map((item, index) => {
                if (item.aksiyon === "URINER") {
                    const nextItem = takvim[index + 1];
                    if (nextItem) {
                        const urinerTarih = moment(item.tarih, "DD.MM.YYYY");
                        const expectedDate = urinerTarih.add(urinGun, "days").format("DD.MM.YYYY");
                        if (nextItem.tarih !== expectedDate) {

                            alert(`${index + 1} numaralı Üriner günlük aksiyonundan sonra gelen aksiyon en erken ${urinGun} sonra olmalıdır!`)

                            hataVar = true;
                        }
                    }
                }
            });


            setTimeout(() => {
                resolve(hataVar ? true : false)
            }, 100)
        });
    };

    const ilkAksiyonKontrol = () => {
        if (takvim.length > 0) {
            if (takvim[0].aksiyon != "TEDAVI") {
                const tmpTakvim = [...takvim];
                tmpTakvim[0] = { ...tmpTakvim[0], hata: "İlk aksiyon tedavi olmak zorunda!" };
                setTakvim(tmpTakvim);
            } else {
                return true;
            }
        }

        return false;
    }

    const sonAksiyonKontrol = () => {
        if (takvim.length > 0) {
            if (takvim[takvim.length - 1].aksiyon != "ANKET") {
                const tmpTakvim = [...takvim];
                tmpTakvim[takvim.length - 1] = { ...tmpTakvim[takvim.length - 1], hata: "Son aksiyon anket olmak zorunda!" };
                setTakvim(tmpTakvim);
            } else {
                return true;
            }
        }

        return false;
    }

    const btnTedaviAta = async () => {

        if (takvim.filter(x => x.aksiyon == "TEDAVI").length < 1) {
            MySwal.fire({
                title: "En az bir tedavi aksiyonu eklenmeli!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        if (takvim.filter(x => x.aksiyon == "ANKET").length < 1) {
            MySwal.fire({
                title: "En az bir anket aksiyonu eklenmeli!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        if (takvim.filter(x => x.aksiyon == "URINER").length < 1) {
            MySwal.fire({
                title: "En az bir uriner aksiyonu eklenmeli!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }


        setTakvim(prev =>
            prev.map(takvim => ({ ...takvim, hata: "" }))
        );

        if (!ilkAksiyonKontrol()) {
            MySwal.fire({
                title: "İlk aksiyon tedavi olmak zorunda!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        if (!sonAksiyonKontrol()) {
            MySwal.fire({
                title: "Son aksiyon anket olmak zorunda!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        const urinerHataDurumu = await urinerKontrol();

        if (urinerHataDurumu) return;

        takvim.map((item, index) => {
            if (index == 0) {
                if (item.aksiyon != "TEDAVI") {
                    const tmpTakvim = [...takvim];
                    tmpTakvim[index] = { ...tmpTakvim[index], hata: "1. aksiyon tedavi olmak zorunda!" };
                    setTakvim(tmpTakvim);
                }
            }
        });

        if (btnLoading) return;

        MySwal.fire({
            title: t('islemi_onayla'),
            html: "<i>" + t('tedavi_atanmak_uzere') + "</i>",
            icon: 'warning',
            confirmButtonText: t('evet'),
            denyButtonText: t('hayir'),
            showDenyButton: true
        }).then((x) => {
            if (x.isConfirmed) {
                tedaviAta()
            }
        })
    }

    const tedaviAta = () => {
        setBtnLoading(true)
        const url = server + prefix + endpoints.tedavi_ata
        api.request(url, "POST", {
            kullanici_kodu: kk,
            recete_id: recete.id,
            uriner_gun: urinGun,
            takvim
        }, { "Authorization": "Bearer " + token }).then((response) => {

            const { hata, mesaj } = response.data;

            MySwal.fire({
                title: mesaj,
                icon: hata ? 'warning' : 'success',
                confirmButtonText: t('tamam'),
            }).then((x) => {
                if (x.isConfirmed) {
                    if (!hata) {
                        navigate("/hasta/goruntule/" + kk + "?tab=tab2")
                    }
                }
            })

            setBtnLoading(false)
        }).catch((err) => {
            setLoading(false)
            alert(err)
        })
    }

    const btnManuelAksiyon = () => {
        if (takvim.length < 1) {
            MySwal.fire({
                title: "Önce otomatik takvim oluşturulmalıdır.",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        setMaModal(true)
    }

    const btnManuelAksiyonDuzenle = (item) => {
        setMaEditAksiyon(item.aksiyon)
        setEditMaTarih(moment(item.tarih, "DD.MM.YYYY").format("YYYY-MM-DD"))
        setEditMaUuid(item.uuid)

        setMaEditModal(true)
    }

    const manuelAksiyonEkle = () => {
        if (takvim.length < 1) return;

        if (maAksiyon == "") {
            MySwal.fire({
                title: "Aksiyon seçilmedi!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        if (maTarih == null) {
            MySwal.fire({
                title: "Aksiyon tarihi seçilmedi!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        const tmpAksiyon = maAksiyon;
        const tmpTarih = moment(maTarih).format("DD.MM.YYYY")

        // Bir güne aynı aksiyondan birden fazla eklenemez
        if (takvim.filter(x => x.tarih == tmpTarih && x.aksiyon == tmpAksiyon).length > 0) {
            MySwal.fire({
                title: `<span style="font-size:18px">
                ${tmpTarih} tarihinde zaten bir ${t(tmpAksiyon)} aksiyonu var!
                </span>`,
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        const baslangicTarihi = moment(takvim[0].tarih, "DD.MM.YYYY");
        const bitisTarihi = moment(takvim[takvim.length - 1].tarih, "DD.MM.YYYY");
        const at = moment(tmpTarih, "DD.MM.YYYY");

        if (at.isBefore(baslangicTarihi, 'day')) {
            MySwal.fire({
                title: `<span style="font-size:18px">
                Başlangıç tarihinden önce bir aksiyon ekleyemezsiniz.
                </span>`,
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        if (at.isAfter(bitisTarihi, 'day') && tmpAksiyon != "ANKET") {
            MySwal.fire({
                title: `<span style="font-size:18px">
                Bitiş tarihinden sonra anket haricinden başka bir aksiyon eklenemez!
                </span>`,
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        setTakvim((prev) => [...prev, { aksiyon: tmpAksiyon, tarih: tmpTarih, label: t(tmpAksiyon.toLowerCase()) }])

        setTimeout(() => {
            const order = ["TEDAVI", "ANKET", "URINER"];

            setTakvim(prevTakvim =>
                [...prevTakvim].sort((a, b) => {
                    const dateA = moment(a.tarih, "DD.MM.YYYY");
                    const dateB = moment(b.tarih, "DD.MM.YYYY");

                    if (dateA.isBefore(dateB)) return -1;
                    if (dateA.isAfter(dateB)) return 1;

                    return order.indexOf(a.aksiyon) - order.indexOf(b.aksiyon);
                })
            );
        }, 100)
    }

    const manuelAksiyonDuzenle = () => {
        if (takvim.length < 1) return;

        if (maEditTarih == null) {
            MySwal.fire({
                title: "Aksiyon tarihi seçilmedi!",
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        const tmpAksiyon = maEditAksiyon;
        const tmpTarih = moment(maEditTarih).format("DD.MM.YYYY")

        // Bir güne aynı aksiyondan birden fazla eklenemez
        if (takvim.filter(x => x.tarih == tmpTarih && x.aksiyon == tmpAksiyon).length > 0) {
            MySwal.fire({
                title: `<span style="font-size:18px">
                ${tmpTarih} tarihinde zaten bir ${t(tmpAksiyon)} aksiyonu var!
                </span>`,
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        const baslangicTarihi = moment(takvim[0].tarih, "DD.MM.YYYY");
        const bitisTarihi = moment(takvim[takvim.length - 1].tarih, "DD.MM.YYYY");
        const at = moment(tmpTarih, "DD.MM.YYYY");

        if (at.isBefore(baslangicTarihi, 'day')) {
            MySwal.fire({
                title: `<span style="font-size:18px">
                Başlangıç tarihinden önce bir aksiyon ekleyemezsiniz.
                </span>`,
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        if (at.isAfter(bitisTarihi, 'day') && tmpAksiyon != "ANKET") {
            MySwal.fire({
                title: `<span style="font-size:18px">
                Bitiş tarihinden sonra anket haricinden başka bir aksiyon eklenemez!
                </span>`,
                icon: "error",
                confirmButtonText: t('tamam'),
            })
            return;
        }

        setTakvim(prevList =>
            prevList.map(item =>
                item.uuid === maEditUuid
                    ? { ...item, ...{ tarih: tmpTarih } }
                    : item
            )
        );

        const order = ["TEDAVI", "ANKET", "URINER"];

        setTakvim(prevTakvim =>
            [...prevTakvim].sort((a, b) => {
                const dateA = moment(a.tarih, "DD.MM.YYYY");
                const dateB = moment(b.tarih, "DD-MM-YYYY");

                if (dateA.isBefore(dateB)) return -1;
                if (dateA.isAfter(dateB)) return 1;

                return order.indexOf(a.aksiyon) - order.indexOf(b.aksiyon);
            })
        );

        setMaEditModal(false)
    }

    const aksiyonSil = (item) => {
        const tmpTakvim = takvim.filter(x => x.uuid != item.uuid);
        setTakvim(tmpTakvim)
    }

    return (
        <Layout baslik={t('tedavi_ata')}>

            <Modal
                isOpen={maEditModal}
                onRequestClose={() => setMaEditModal(false)}
                style={maModalStyle}>

                <h3>Manuel Aksiyon Düzenleme Ekranı</h3>
                <hr />

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="manuelEditAksiyon">Aksiyon</label>
                            <select value={maEditAksiyon} id="manuelEditAksiyon" className="form-control" disabled>
                                <option value="TEDAVI">Tedavi</option>
                                <option value="ANKET">Anket</option>
                                <option value="URINER">Üriner</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="manuelEditAksiyonTarihi">Tarih</label>
                            <input value={maEditTarih} onChange={(e) => setEditMaTarih(e.target.value)} id="manuelEditAksiyonTarihi" type="date" className="form-control" />
                        </div>
                    </div>
                </div>

                <button onClick={manuelAksiyonDuzenle} className="btn btn-outline-dark btn-block">
                    <i className="fas fa-check"></i> Aksiyonu Güncelle
                </button>

            </Modal>

            <Modal
                isOpen={maModal}
                onRequestClose={() => setMaModal(false)}
                style={maModalStyle}>

                <h3>Manuel Aksiyon Ekleme Ekranı</h3>
                <hr />

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="manuelAksiyon">Aksiyon</label>
                            <select value={maAksiyon} onChange={(e) => setMaAksiyon(e.target.value)} id="manuelAksiyon" className="form-control">
                                <option value="">Seçilmedi</option>
                                <option value="TEDAVI">Tedavi</option>
                                <option value="ANKET">Anket</option>
                                <option value="URINER">Üriner</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="manuelAksiyonTarihi">Tarih</label>
                            <input value={maTarih} onChange={(e) => setMaTarih(e.target.value)} id="manuelAksiyonTarihi" type="date" className="form-control" />
                        </div>
                    </div>
                </div>

                <button onClick={manuelAksiyonEkle} className="btn btn-outline-dark btn-block">
                    <i className="fas fa-check"></i> Aksiyonu Ekle
                </button>

            </Modal>

            <div className="row">
                <div className="col-md-6 col-12">
                    <div className="card shadow">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-md-6">
                                    <TedaviProtokolu recete={recete} setRecete={setRecete} />
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="uriner_gun_sanisi">{t("uriner_gun_sayisi")}</label>
                                        <select defaultValue={2} value={urinGun} onChange={(e) => setUriGun(e.target.value)} name="uriner_gun_sanisi" id="uriner_gun_sanisi" className="form-control">
                                            <option value="2">2 {t('gun')}</option>
                                            <option value="3">3 {t('gun')}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="baslangic_tarihi">{t('tedavi_baslangic_tarihi')}</label>
                                        <input name="baslangic_tarihi" id="baslangic_tarihi" type="date" value={baslangicTarihi} onChange={(e) => setBaslangicTarihi(e.target.value)} className="form-control" />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex align-items-center h-100">
                                        <button onClick={btnManuelAksiyon} className="btn btn-outline-dark btn-block mt-3">
                                            <i className="fas fa-plus"></i> Manuel Aksiyon Ekle
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {
                                loading ?
                                    <>
                                        <div className="text-center mt-5">
                                            <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
                                            <p>{t("yukleniyor...")}</p>
                                        </div>
                                    </>
                                    :
                                    <>
                                        {takvim.length > 0 && (
                                            <>
                                                <div className="table-responsive">
                                                    <table className="table table-striped table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-center' style={{ width: 50 }}>#</th>
                                                                <th className='text-center' style={{ width: 150 }}>{t("tarih")}</th>
                                                                <th className='text-center' style={{ width: 100 }}>{t("aksiyon")}</th>
                                                                <th className='text-center' style={{ width: 50 }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                takvim.map((item, index) => (
                                                                    <tr>
                                                                        <td className='text-center'>{index + 1}</td>
                                                                        <td className='text-center'>{item.tarih}</td>
                                                                        <td className='text-center'>
                                                                            {item.aksiyon === "TEDAVI" && (
                                                                                <span className="badge badge-success">{t(item.aksiyon)}</span>
                                                                            )}
                                                                            {item.aksiyon === "URINER" && (
                                                                                <span className="badge badge-danger">{t(item.aksiyon)}</span>
                                                                            )}
                                                                            {item.aksiyon === "ANKET" && (
                                                                                <span className="badge badge-info">{t(item.aksiyon)}</span>
                                                                            )}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            <button onClick={() => btnManuelAksiyonDuzenle(item)} title="Düzenle" className="btn btn-outline-info btn-sm">
                                                                                <i className="fas fa-edit"></i>
                                                                            </button>
                                                                            <button onClick={() => aksiyonSil(item)} title="Sil" className="btn btn-outline-danger btn-sm ml-2">
                                                                                <i className="fas fa-trash-alt"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <button
                                                    onClick={btnTedaviAta}
                                                    className="btn btn-danger btn-block"
                                                >
                                                    {btnLoading ? (
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> {t("isleniyor")}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-check"></i> {t("tedavi_ata")}
                                                        </>
                                                    )}
                                                </button>
                                            </>
                                        )}
                                    </>

                            }

                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-12">
                    <div className="card shadow">
                        <div className="card-body">
                            <h4>{t('tedavi_protokolu_bilgileri')}</h4>

                            {
                                recete == null ?
                                    <>
                                        <p class="text-danger">{t('tedavi_protokolu_secilmedi')}</p>
                                    </>
                                    :
                                    <>
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="recete_adi">{t('tp_adi')}</label>
                                                <input id="recete_adi" value={recete.recete_adi} type="text" className="form-control" disabled />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="ayak">{t('ayak')}</label>
                                                <select defaultValue={recete.uygulanacak_ayak} id="ayak" className="form-control" disabled>
                                                    <option value="">{t('secim_yapilmadi')}</option>
                                                    <option value="SOL">{t('SOL')}</option>
                                                    <option value="SAG">{t('SAG')}</option>
                                                    <option value="CIFT">{t('CIFT')}</option>
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <div style={{ display: 'flex' }}>
                                                    <label htmlFor="hafta_sayisi" style={{ flex: 1 }}>{t('hafta_sayisi')}</label>
                                                    <label htmlFor="hafta_sayisi">{recete.hafta_sayisi}</label>
                                                </div>
                                                <input id="hafta_sayisi" type="range" className="custom-range" value={recete.hafta_sayisi} min={ayarlar.en_az_hafta_sayisi} max={ayarlar.en_fazla_hafta_sayisi} step="1" />
                                            </div>

                                            <div className="form-group">
                                                <div style={{ display: 'flex' }}>
                                                    <label htmlFor="haftadaki_siklik" style={{ flex: 1 }}>{t('haftadaki_siklik')}</label>
                                                    <label htmlFor="haftadaki_siklik">{recete.siklik}</label>
                                                </div>
                                                <input id="haftadaki_siklik" type="range" className="custom-range" value={recete.siklik} min={ayarlar.en_az_haftadaki_siklik} max={ayarlar.en_fazla_haftadaki_siklik} step="1" />
                                            </div>

                                            <div className="form-group">
                                                <div style={{ display: 'flex' }}>
                                                    <label htmlFor="tedavi_suresi" style={{ flex: 1 }}>{t('tedavi_suresi_dk')}</label>
                                                    <label htmlFor="tedavi_suresi">{recete.tedavi_suresi}</label>
                                                </div>
                                                <input id="tedavi_suresi" type="range" className="custom-range" value={recete.tedavi_suresi} min={ayarlar.en_az_tedavi_suresi} max={ayarlar.en_fazla_tedavi_suresi} step="1" />
                                            </div>

                                            <div className="form-group">
                                                <div style={{ display: 'flex' }}>
                                                    <label htmlFor="frekans" style={{ flex: 1 }}>{t('frekans_hz')}</label>
                                                    <label htmlFor="frekans">{recete.frekans}</label>
                                                </div>
                                                <input id="frekans" type="range" className="custom-range" value={recete.frekans} min={ayarlar.en_az_frekans} max={ayarlar.en_fazla_frekans} step="1" />
                                            </div>

                                            <div className="form-group">
                                                <div style={{ display: 'flex' }}>
                                                    <label htmlFor="darbe_genisligi" style={{ flex: 1 }}>{t('dbg_mikro_sn')}</label>
                                                    <label htmlFor="darbe_genisligi">{recete.darbe_genisligi}</label>
                                                </div>
                                                <input id="darbe_genisligi" type="range" className="custom-range" value={recete.darbe_genisligi} min={ayarlar.en_az_darbe_genisligi} max={ayarlar.en_fazla_darbe_genisligi} step={20} />
                                            </div>

                                        </div>

                                    </>
                            }

                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    )
}

const maModalStyle = {
    content: {
        minWidth: '35%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};